import { render, staticRenderFns } from "./ChangeServe.vue?vue&type=template&id=2afa9549&scoped=true&"
import script from "./ChangeServe.vue?vue&type=script&lang=js&"
export * from "./ChangeServe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2afa9549",
  null
  
)

export default component.exports